var map = {
	"./approved.svg": 457,
	"./arrow-blue.svg": 584,
	"./arrow-down.svg": 452,
	"./arrow.svg": 29,
	"./arrowBackwards.svg": 151,
	"./arrowBlue.svg": 577,
	"./back-arrow.svg": 401,
	"./bell-icon.svg": 1063,
	"./blue.svg": 1064,
	"./change-password.svg": 1065,
	"./chasingstats.svg": 1066,
	"./close-icon.svg": 498,
	"./close.svg": 110,
	"./closeIcon.svg": 264,
	"./dashboard-new/filter-clear.svg": 590,
	"./dashboard-new/graph1.svg": 593,
	"./dashboard-new/graph2.svg": 594,
	"./dashboard-new/graph3.svg": 595,
	"./dashboard-new/graph4.svg": 596,
	"./dashboard-new/long-arrow.svg": 462,
	"./dashboard-new/menu.svg": 493,
	"./dashboard.svg": 399,
	"./dd-arrow.svg": 21,
	"./deemed.svg": 459,
	"./doc.svg": 197,
	"./document.svg": 1067,
	"./edit.svg": 198,
	"./efficency_circle.svg": 576,
	"./equalizer.svg": 322,
	"./expandIcon.svg": 1068,
	"./fire-extinguisher.svg": 586,
	"./flag-deemed.svg": 1069,
	"./flag-green.svg": 1070,
	"./flag-orange.svg": 1071,
	"./flag-red.svg": 1072,
	"./graph.svg": 212,
	"./green.svg": 1073,
	"./growth-icon.svg": 1074,
	"./growth.svg": 400,
	"./id.svg": 1075,
	"./irrigation.svg": 585,
	"./leftarrow.svg": 199,
	"./logout.svg": 494,
	"./mail.svg": 581,
	"./mail_active.svg": 580,
	"./more.svg": 1076,
	"./notSuccess.svg": 460,
	"./orange.svg": 1077,
	"./password.svg": 450,
	"./pdf.svg": 133,
	"./plus.svg": 321,
	"./police.svg": 587,
	"./print.svg": 1078,
	"./raise_shortfall.svg": 1079,
	"./received.svg": 456,
	"./red.svg": 1080,
	"./rejected.svg": 458,
	"./report.svg": 1081,
	"./rupee-circle.svg": 1082,
	"./rupee.svg": 1083,
	"./scrutinity.svg": 495,
	"./search.svg": 323,
	"./sms.svg": 579,
	"./sms_active.svg": 578,
	"./success-grey.svg": 1084,
	"./success.svg": 149,
	"./successDarkGreen.svg": 461,
	"./successLightGreen.svg": 453,
	"./tax.svg": 1085,
	"./technical-support.svg": 1086,
	"./tick.svg": 574,
	"./tick_1.svg": 583,
	"./user-alt-1-svgrepo-com.svg": 1087,
	"./v-down-active.svg": 1088,
	"./v-down-inactive.svg": 455,
	"./v-down.svg": 1089,
	"./verification-active.svg": 1090,
	"./verification.svg": 1091,
	"./watch.svg": 1092
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 597;